export class VRMRequest {
        constructor(
                public VRM: string
        ) { }
}